module.exports = __webpack_public_path__ + "img/item_Story_09.fdd0b373.jpeg";